import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      whileHover={{ scale: 1.07 }}
      whileTap={{ scale: 0.93 }}
      title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      style={{
        width: 32, height: 32,
        background: 'var(--bg-card)',
        border: `1px solid var(--border)`,
        borderRadius: 8,
        cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'var(--text-muted)',
        transition: 'all 0.2s ease',
      }}
    >
      <motion.div
        initial={false}
        animate={{ rotate: isDarkMode ? 0 : 180, scale: 1 }}
        transition={{ duration: 0.35 }}
      >
        {isDarkMode ? <FiMoon size={15} /> : <FiSun size={15} />}
      </motion.div>
    </motion.button>
  );
};

export default ThemeToggle;
